import OBase from './OBase';

import * as Geometry from '../geometry';

export default class GateNot extends OBase {
  update () {
    var aValTree = this.getBoolInput('A');

    var rOutput = this.getGenericObjectOutput('Result');

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < aValTree.branches.length; i++) {
      for (let j = 0; j < aValTree.branches[i].length; j++) {
        var aVal = aValTree.branches[i][j];

        let val = !aVal;

        outTree.add(val, aValTree.paths[i]);
      }
    }

    rOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/GateNot.js